import { render } from "./product-yotpo-stars.vue?vue&type=template&id=33857de6"
import script from "./product-yotpo-stars.vue?vue&type=script&lang=js"
export * from "./product-yotpo-stars.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__